import React from 'react';

interface FormRowProps {
  columns?: 1 | 2;
  gap?: number;
  children: React.ReactNode;
}

const FormRow: React.FC<FormRowProps> = ({ columns = 2, gap = 12, children }) => {
  const style: React.CSSProperties = columns === 2
    ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap }
    : { display: 'grid', gridTemplateColumns: '1fr', gap };
  return <div style={style}>{children}</div>;
};

export default FormRow; 